export type Salesman = {
  name: string;
  role: string;
  imageUrl: string;
};

const salesmen: Salesman[] = [
  {
    name: 'Pascal Piroué',
    role: 'Geschäftsführer',
    imageUrl: '/salesman/Piroue.webp',
  },
  {
    name: 'Martin Schöttl-Pichlmaier',
    role: 'Leitung Supply Chain, Prokurist, Einkaufsleiter',
    imageUrl: '/salesman/Schoettl-Pichlmaier.webp',
  },
  {
    name: 'Georg Seitz',
    role: 'stellv. Einkaufsleiter, Einkauf Hallertau und Elbe-Saale',
    imageUrl: '/salesman/Seitz.webp',
  },
  {
    name: 'Maria Berger',
    role: 'Leitung Hopfenvermehrung, Einkauf Hallertau',
    imageUrl: '/salesman/Berger.webp',
  },
  {
    name: 'Florian Fritsch',
    role: 'Einkauf Hallertau',
    imageUrl: '/salesman/Fritsch.webp',
  },
  {
    name: 'Michael Bauer',
    role: 'Einkauf Hallertau und Elbe-Saale',
    imageUrl: '/salesman/Bauer.webp',
  },
  {
    name: 'Johanna Fischbacher',
    role: 'Einkauf Hallertau, Lagerlogistik',
    imageUrl: '/salesman/Fischbacher.webp',
  },
  {
    name: 'Maximilian Stadler',
    role: 'Einkauf Hallertau und Elbe-Saale',
    imageUrl: '/salesman/Stadler.webp',
  },
  {
    name: 'Petra Körndl',
    role: 'Einkauf Hallertau',
    imageUrl: '/salesman/Koerndl.webp',
  },
  {
    name: 'Johannes Spielberger',
    role: 'Einkauf Hallertau',
    imageUrl: '/salesman/Spielberger.webp',
  },
  {
    name: 'Andreas Joos',
    role: 'Einkauf Tettnang',
    imageUrl: '/salesman/Joos-Andreas.webp',
  },
  {
    name: 'Steffen Joos',
    role: 'Einkauf Tettnang',
    imageUrl: '/salesman/Joos-Steffen.webp',
  },
  {
    name: 'Antonia Kuffer',
    role: 'Einkauf Hallertau, Musterlogistik, Hopfenvermehrung',
    imageUrl: '/salesman/Kuffer.webp',
  },
  {
    name: 'Christoph Wimmer',
    role: 'Einkauf Hallertau, Lagerlogistik',
    imageUrl: '/salesman/Wimmer.webp',
  },
  {
    name: 'Cornelia Kollmannsberger',
    role: 'Sachbearbeitung Elbe Saale, Hallertau und Tettnang',
    imageUrl: '/salesman/Kollmannsberger.webp',
  },
  {
    name: 'Anita Schauer',
    role: 'Sachbearbeitung Hallertau',
    imageUrl: '/salesman/Schauer.webp',
  },
  {
    name: 'Ursula Zeilmaier',
    role: 'Sachbearbeitung Hallertau',
    imageUrl: '/salesman/Zeilmaier.webp',
  },
];

export default salesmen;
